import { render, staticRenderFns } from "./TomadaPreco.vue?vue&type=template&id=6a8bd957"
import script from "./TomadaPreco.vue?vue&type=script&lang=js"
export * from "./TomadaPreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports